module finadai.app.changePassword {
  export var NAME = 'finadai.app.changePassword';
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider){
    $stateProvider.state('changePassword', {
      templateUrl: "app/changePassword/changePassword.tpl.html",
      url: "/updatePassword",
      controller: "ChangePasswordController",
      params: { token: '', email: '' }
    })
    .state('forgotPassword', {
      templateUrl: "app/changePassword/forgotPassword.tpl.html",
      url: "/forgotPassword",
      controller: "ForgotPasswordController",
      params: { email: '' }
    })
    .state('resetPassword', {
      templateUrl: "app/changePassword/changePassword.tpl.html",
      url: "/resetPassword/:token",
      controller: "ChangePasswordController"
    });
  }
  function ChangePasswordController($scope, $stateParams, $state: ng.ui.IStateService, authService: services.AuthService, $localStorage: IFinadaiStorage, notify) {
    $scope.loggedIn = $stateParams.loggedIn;
    $scope.formData = { token: $stateParams.token };
    $scope.isUpdatePassword = $state.is('changePassword');
    if($state.is('changePassword') && $stateParams.token == ''){
      $state.go('login');
    }
    $scope.submit = (form) => {
      if(form.$valid){
        if($state.is('changePassword')){
          authService.changeDefaultPassword($scope.formData).then(response => {
            authService.login({ email: $stateParams.email, password: $scope.formData.password}).then(response => {
              $localStorage.apiToken = "Bearer " + response.data.token;
              $state.go('app.dashboard');
            })
          });
        }
        else if($state.is('resetPassword')){
          authService.resetPassword($scope.formData).then(response => {
            notify('Contraseña actualizada');
            $state.go('login');
          }, responseError => {
            if(angular.isDefined(responseError.data.errors))
            $scope.errorMessages = responseError.data.errors['Bad Request'];
          });
        }
        else{
          authService.changePassword($scope.formData).then(response => {
            notify('Contraseña actualizada');
          });
        }
      }
    }
  }
  export function run(){
    var changePassword = angular.module(NAME, []);
    changePassword.config(ConfigRoutes);
    changePassword.controller('ChangePasswordController', ChangePasswordController)
  }
} finadai.app.changePassword.run();